import {
  Component,
  OnInit,
} from '@angular/core';

import { AlertController, MenuController } from '@ionic/angular';
// import { Storage } from '@ionic/storage';
import { Storage } from '@ionic/storage-angular';
import { DataService } from '../../services/data.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-web-header',
  templateUrl: './web-header.component.html',
  styleUrls: ['./web-header.component.scss'],
})
export class WebHeaderComponent implements OnInit {

  constructor(private menu: MenuController,public db: DataService,private alertCtrl: AlertController,private storage: Storage,public router:Router) { }

  ngOnInit() {}

  async logout() {

    let alert = await this.alertCtrl.create({
      header: 'Confirm',
      message: 'Do you really want to logout?',
      buttons: [
        {
          text: 'No',
          role: 'cancel'
        },
        {
          text: 'Yes',
          handler: () => {
            localStorage.clear();
            this.storage.remove('category_list');
            this.storage.remove('customer_list');
            this.storage.remove('inventroy_items');
            this.storage.remove('selectmenu');
            this.storage.clear();
            this.router.navigateByUrl('/login');
            this.menu.enable(false, 'profileMenu');

            //  this.router.navigateByUrl('/');
          }
        }
      ]
    })
    await alert.present();
  }

}
